<template>
  <mdb-container fluid id="home">
    <mdb-row class="pt-3 pb-3 d-flex blue-header">
      <mdb-col class="col-12 text-left pl-4 pr-4">
        <img
          class="logo"
          src="../assets/img/csc-white.svg"
          width="140"
          height="49"
        />
        <a
          class="link light consult-position"
          target="_blank"
          href="https://www.csc.gov.au/Employers/Contact-us"
        >
          <img
            class="icon-arrow-help"
            src="../assets/icons/big-arrow-white-outline.svg"
          />
          <span>Need help? Contact us</span>
        </a>
      </mdb-col>
    </mdb-row>

    <mdb-row class="pt-5 hero-img">
      <div class="img-mask"></div>
    </mdb-row>

    <mdb-row class="pt-4 pb-4 text-center">
      <mdb-col class="col-12">
        <h2>
          AWOTE calculator
        </h2>
      </mdb-col>
    </mdb-row>

    <mdb-row class="pb-3 text-center">
      <mdb-col class="col-10 mx-auto pr-sm-5">
        <h3>
          Calculate superannuation salaries for CSS, PSS and PSSap members who
          have had a reduction in their salary
        </h3>
      </mdb-col>
    </mdb-row>

    <mdb-row class="text-center">
      <mdb-col class="col-12 mb-4 pt-4">
        <router-link to="/about" class="rounded btn btn-primary ripple-parent">
          Let's get started <i class="fas icon-arrow"></i>
        </router-link>

        <br /><br />
        <router-link class="underln" to="/help"
          >When should I use AWOTE?</router-link
        >
        <br />

        <div class="d-none d-lg-none pt-4">
          <a href="#">
            <img class="icon-convo" src="../assets/icons/conversation.svg" />
            Not sure? Book an appointment with us.
          </a>
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col class="pt-3 pt-lg-5 pl-sm-5 pr-sm-5">
        <LastUpdate />

        <br /><br />

        <a
          class="btn-text ripple-parent disclaimer"
          @click="showDisclaimerModal = true"
          >DISCLAIMER</a
        >
        <mdb-modal
          :show="showDisclaimerModal"
          @close="showDisclaimerModal = false"
          centered
        >
          <mdb-modal-body class="text-left">
            <h4>
              Disclaimer
            </h4>
            <p>
              This calculator has been developed to assist employers to
              calculate superannuation salaries for CSS, PSS and PSSap members
              who have had a reduction in their salary.
            </p>
            <p>
              The results of the calculator are based on data that you enter,
              and CSC is not responsible for any errors arising from the input
              of incorrect or incomplete data to the calculator.
            </p>
            <p>
              You should ensure that all employee and employer information in
              the calculator is complete.
            </p>
          </mdb-modal-body>
          <mdb-modal-footer>
            <mdb-btn
              class="rounded"
              color="primary"
              @click.native="showDisclaimerModal = false"
              >Close</mdb-btn
            >
          </mdb-modal-footer>
        </mdb-modal>
      </mdb-col>
    </mdb-row>

    <mdb-row class="no-gutters">
      <mdb-col>
        <Footer />
        <div id="feedback">
          <a
            href="https://feedback.csc.gov.au/cgi-bin/qwebcorporate.dll?idx=SQ6N45&type=AHC"
            target="_blank"
          >
            Feedback
          </a>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<style lang="scss">
@import "~@/scss/home.scss";
</style>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbModal,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";

import LastUpdate from "@/components/LastUpdate.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbModal,
    mdbModalBody,
    mdbModalFooter,
    LastUpdate,
    Footer
  },

  data() {
    return {
      showDisclaimerModal: false
    };
  },

  mounted() {
    window.triggerResize();
    setTimeout(function() {
      window.triggerResize();
    }, 250);
  }
};
</script>
